import { useEffect, useState } from 'react'
import '../CSSFiles/NavBar.css'
import auto_logo from "../Images/main_logo.png"
import "../CSSFiles/AdminDashboard.css"
import { Helmet } from 'react-helmet'


export const AdminDashboard = () => {

    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];

    const [appointments_array, set_appointments_array] = useState([])
    const [should_display, set_should_display] = useState(false)
    const FetchAppointments = () => {
        fetch('https://nnduck12345.org/public-projects/nova_auto_repairs/get_appointments.php') // 🔁 Replace with your actual endpoint
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
            set_appointments_array(data.data);
            console.log(data.data)
            } else {
            console.error('Error fetching appointments:', data.message);
            }
        })
        .catch(error => {
            console.error('Fetch error:', error);
        });
    }

    useEffect(() => {
        if (document.cookie.includes("nova_automatic_repairs_password_admin_dashboard") || true) {
            set_should_display(true);
            FetchAppointments()
        }
    }, [])
    const HumanReadableTime = (date, time) => {

        const new_date = new Date(`${date}T${time}`);

        return (dayNames[new_date.getDay()] + ", " + months[new_date.getMonth()] + " " + new_date.getDate() + ", " + new_date.getHours() + ":" + new_date.getMinutes());
    }

  

    if (!should_display) {
        return <h1> Note: Set this up later</h1>
    }
    return <div className="admin-dashboard">
       <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        </Helmet>
            <div className="nav-bar">
                <div className='top-nav-bar'>
                    <h3> Nova Auto Repair</h3>
                </div>
                <div className='bottom-nav-bar'>
                    <div className="nav-bottom-left">
                        <img src={auto_logo} alt="weed"/>
                    </div>
                   
                </div>
            </div>
        

        <div className="dashboard-content">


            {appointments_array.map((item) => {
                return <div className="appointment-slot" key={item.id}>

                    <h2> {item.id} : {item.first_name} {item.last_name}</h2>
                    <p> time: {HumanReadableTime(item.date, item.time)}</p>
                    <p> Phone number: {item.phone_number}</p>
                    <p> Email: {item.email}</p>
                    <p> Reason for visit: {item.purpose}</p>
                    <p> Code: {item.code}</p>
                </div>
            })}
        </div>
    </div>
}